export default class perfiltrayectoriatable{

    constructor($scope,$uiGridConstants,$http,perfilSrv,ngNotify,UserInfoConstant,$cookies,$stateParams,$state, i18nService){
        this.$scope = $scope;
        this.$uiGridConstants = $uiGridConstants;
        this.$http = $http;
        this.perfilSrv = perfilSrv;
        this.ngNotify = ngNotify;
        this.$cookies = $cookies;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$scope.gridOptionsComplex = {
            enableFiltering: true,
            enableGridMenu: true,
            showFooter: true,
            rowHeight: 36,
            columnDefs: [
            { displayName: 'Institución',field:'Institucion', width: '20%' },
            { displayName: 'Cargo',field:'Cargo', width: '15%' },
            { displayName: 'Año de Inicio',field:'AnoInicio', width: '15%' },
            { displayName: 'Año de Fin',field:'AnoFin', width: '15%' }
            ]
        };
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
        i18nService.setCurrentLang('es')
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.trayectoriaprevia(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    } else {
                        this.$state.go('profile.perfil_dash');
                        this.ngNotify.set('No se ha especificado ningún docente', 'info');
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    goBack(){
        this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.trayectoriaprevia(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    trayectoriaprevia(teacherId) {
        this.perfilSrv.perfildocente.trayectoriaprevia({teacherId:teacherId}).$promise.then((dataReturn) => {   
            this.$scope.gridOptionsComplex.data = dataReturn.data;
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });        
    }
}

perfiltrayectoriatable.$inject = ['$scope','uiGridConstants','$http','perfilSrv','ngNotify','UserInfoConstant','$cookies', '$stateParams','$state', 'i18nService'];








// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/Trayectoria_Previa/Trayectoria_PreviaCtrl.js